/**
 * Floating island — smooth drop → expand (transform-only) → reveal marquee
 */
(function () {
  const REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function finishReady(bar, root) {
    bar.classList.remove('is-intro', 'is-prep', 'is-animating');
    bar.classList.add('is-ready');
    bar.style.transform = 'translate3d(-50%, 0, 0)';
    bar.style.width = '';
    bar.style.maxWidth = '';
    bar.style.opacity = '';
    root.__faIntroDone = true;
  }

  function runIntro(root) {
    if (!root || root.__faIntroDone) return;
    const bar = root.querySelector('.announcement-bar');
    if (!bar) return;

    const wantsIntro = root.getAttribute('data-fa-intro') === 'true';
    if (!wantsIntro || REDUCE || bar.classList.contains('announcement-bar--full')) {
      finishReady(bar, root);
      return;
    }

    root.__faIntroDone = true;

    // Measure final island size invisibly
    bar.classList.remove('is-intro', 'is-ready', 'is-dropped', 'is-expanded');
    bar.classList.add('is-prep');

    const rect = bar.getBoundingClientRect();
    const finalW = Math.max(rect.width, 120);
    const seed = Math.max(rect.height, 28);
    const scale0 = Math.max(0.035, Math.min(0.18, seed / finalW));

    bar.style.width = finalW + 'px';
    bar.style.maxWidth = finalW + 'px';
    bar.classList.remove('is-prep');
    bar.classList.add('is-animating');
    bar.style.opacity = '0';
    bar.style.transform = 'translate3d(-50%, -52px, 0) scaleX(' + scale0 + ')';

    const marquee = bar.querySelector('.marquee');
    if (marquee) {
      marquee.style.opacity = '0';
      marquee.style.visibility = 'hidden';
    }

    // Force layout before animating
    void bar.offsetWidth;

    const motion = bar.animate(
      [
        {
          transform: 'translate3d(-50%, -52px, 0) scaleX(' + scale0 + ')',
          opacity: 0,
          offset: 0,
        },
        {
          transform: 'translate3d(-50%, 0, 0) scaleX(' + scale0 + ')',
          opacity: 1,
          offset: 0.34,
        },
        {
          transform: 'translate3d(-50%, 0, 0) scaleX(1)',
          opacity: 1,
          offset: 1,
        },
      ],
      {
        duration: 1180,
        easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
        fill: 'forwards',
      }
    );

    const reveal = function () {
      finishReady(bar, root);
      if (marquee) {
        marquee.style.visibility = 'visible';
        marquee.animate([{ opacity: 0 }, { opacity: 1 }], {
          duration: 380,
          easing: 'ease-out',
          fill: 'forwards',
        });
        // clear after paint so CSS owns opacity
        window.setTimeout(function () {
          marquee.style.opacity = '';
          marquee.style.visibility = '';
        }, 420);
      }
    };

    if (motion && motion.finished) {
      motion.finished.then(reveal).catch(reveal);
    } else {
      window.setTimeout(reveal, 1180);
    }
  }

  function scan() {
    document.querySelectorAll('.rz-floating-announcement').forEach(runIntro);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const root =
      (e.target && e.target.querySelector && e.target.querySelector('.rz-floating-announcement')) ||
      (e.target && e.target.classList && e.target.classList.contains('rz-floating-announcement')
        ? e.target
        : null);
    if (root) {
      root.__faIntroDone = false;
      runIntro(root);
    } else {
      scan();
    }
  });
})();
